export default __webpack_public_path__ + "static/media/Reader's Robes of the Waning Moon.4741d2f3.jpg";